import styled from 'styled-components';
import { rgba } from 'polished';
import { white, primary, neutral, success, error, warning } from '../../../style/colors';

export const StockBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 500;
  color: ${({ stockLevel }) => {
    if (stockLevel === 0) return error.base;
    if (stockLevel >= 1 && stockLevel <= 3) return warning.base;
    return success.base;
  }};

  &::before {
    content: '';
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: currentColor;
  }
`;

export const PriceDisplay = styled.div`
  text-align: right;
  padding: 0;
  background: none;
  border: none;
`;

export const Price = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: ${primary[500]};
  line-height: 1;
  letter-spacing: -0.5px;
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: stretch;
  width: 100%;
  justify-content: flex-end;
`;

export const QuantityControl = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${neutral[200]};
  border-radius: 4px;
  height: 32px;
`;

export const QuantityButton = styled.button`
  background-color: transparent;
  border: none;
  width: 24px;
  height: 100%;
  cursor: pointer;
  font-size: 14px;
  color: ${neutral[500]};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;

  &:hover {
    color: ${neutral[900]};
    background-color: ${neutral[100]};
  }
`;

export const QuantityDisplay = styled.div`
  font-size: 13px;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
  color: ${neutral[900]};
`;

export const AddToCartButton = styled.button`
  background: ${neutral[800]};
  color: ${white};
  border: 1px solid ${neutral[800]};
  padding: 0 16px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 200px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  height: 50px;

  &:hover {
    background: ${neutral[900]};
    border-color: ${neutral[900]};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }

  &:disabled {
    background: ${neutral[200]};
    border-color: ${neutral[200]};
    color: ${neutral[400]};
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }

  i {
    font-size: 16px;
    color: ${primary[500]};
  }
`;

export const IconButton = styled.button`
  background: transparent;
  color: ${neutral[500]};
  border: 1px solid ${neutral[200]};
  width: 32px;
  height: 32px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${neutral[100]};
    border-color: ${neutral[400]};
    color: ${neutral[700]};
  }
`;

export const InquiryButton = styled(IconButton)``;

export const DetailsButton = styled(IconButton)`
  &:hover {
    border-color: ${primary[500]};
    color: ${primary[500]};
    background: transparent;
  }
`;

export const CompareButton = styled.button`
  background: ${({ isInComparison }) => isInComparison ? rgba(primary[500], 0.1) : 'transparent'};
  color: ${({ isInComparison }) => isInComparison ? primary[500] : neutral[500]};
  border: 1px solid ${({ isInComparison }) => isInComparison ? primary[500] : neutral[200]};
  width: 32px;
  height: 32px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: ${primary[500]};
    color: ${primary[500]};
  }
`;

export const ComparisonBadge = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  background: ${primary[500]};
  color: ${white};
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  box-shadow: 0 2px 8px ${rgba(primary[500], 0.4)};
  animation: scaleIn 0.3s ease;
  z-index: 10;

  @keyframes scaleIn {
    from { transform: scale(0); }
    to { transform: scale(1); }
  }

  i { font-size: 14px; }
`;

export const LoadingSpinner = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid ${neutral[900]};
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
